import { Grid, Box, Typography } from "@mui/material";
import { debounce } from "lodash";
import React, { useCallback, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import Checkbox from "../../../../framework/Checkbox";
import GlobalContext from "../../../../framework/GlobalContext";
import NumberInput from "../../../../framework/NumberInput";
import images from "../../../../assets/images";
import {
  checkErrorStateExists,
  formStateHandler,
} from "../../../../utils/utils";

const StockOrPricesTab = (props) => {
  const {
    validateForm = () => {},
    isAddIngredients,
    removeErrorStateOnChange = () => {},
  } = props;

  const { setCurrentComponent } = useContext(GlobalContext);

  const dispatch = useDispatch();

  const { formState, errorState } = useSelector(
    (state) => state.commonReducer.common.addProduct
  );
  const withDpPercentageCap = ({ value }) => value >= 0 && value <= 100;
  const dispatchFormState = useCallback(
    (newState) => {
      dispatch({
        type: "set_add_product_form_state",
        payload: newState,
      });
    },
    [dispatch]
  );

  // eslint-disable-next-line
  const debounceDispatchFormState = useCallback(
    debounce(dispatchFormState, 1),
    []
  );

  const handleFormChange = useCallback(
    (fieldName, fieldValue, isSelect = false, options) => {
      let newFormState = formStateHandler(
        formState,
        fieldName,
        fieldValue,
        isSelect,
        options
      );
      debounceDispatchFormState(newFormState);
    },
    [debounceDispatchFormState, formState]
  );

  return (
    <>
      {!isAddIngredients && (
        <Grid
          container
          spacing={2}
          sx={{
            margin: "5px 0px 5px -10px",
            width: "100%",
          }}
        >
          <Grid
            container
            spacing={2}
            sx={{
              margin: "5px 0 0 5px",
              width: "100%",
            }}
          >
            <Grid item xs={2}>
              <Checkbox
                id="add_product_allow_discount"
                label="Allow Discounts"
                checked={formState?.allowDiscount}
                onChange={(e) => {
                  handleFormChange("allowDiscount", e.target.checked);
                }}
                onFocus={() => {
                  setCurrentComponent("add_product_allow_discount");
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    down: "add_product_tcs",
                    left: "add_product_allow_discount",
                    up: "add_product_allow_discount",
                    right: formState.allowDiscount
                      ? "add_product_disc_per"
                      : "add_product_tcs",
                  }),
                }}
                autoFocus
              />
            </Grid>

            {formState.allowDiscount && (
              <Grid item xs={2}>
                <NumberInput
                  id="add_product_disc_per"
                  name="addProductDiscPer"
                  label="Discount %"
                  onFocus={() => {
                    setCurrentComponent("add_product_disc_per");
                  }}
                  value={formState?.discPer}
                  onChange={(e) => {
                    handleFormChange("discPer", +e.target.value);
                  }}
                  inputProps={{
                    "data-markers": JSON.stringify({
                      up: "add_product_disc_per",
                      down: "add_product_gccess",
                      right: "add_product_max_disc",
                      left: "add_product_allow_discount",
                    }),
                  }}
                />
              </Grid>
            )}
            {formState.allowDiscount && (
              <Grid item xs={2}>
                <NumberInput
                  id="add_product_max_disc"
                  name="addProductMaxDisc"
                  label="Max Discount%"
                  onFocus={() => {
                    setCurrentComponent("add_product_max_disc");
                  }}
                  value={formState?.maxDiscount}
                  onChange={(e) => {
                    handleFormChange("maxDiscount", +e.target.value);
                  }}
                  inputProps={{
                    "data-markers": JSON.stringify({
                      up: "add_product_max_disc",
                      down: "add_product_vat",
                      right: "add_product_tcs",
                      left: "add_product_disc_per",
                    }),
                  }}
                />
              </Grid>
            )}
          </Grid>
          <Grid
            container
            spacing={2}
            sx={{
              margin: "5px 0 0 5px",
              width: "100%",
            }}
          >
            <Grid item xs={2}>
              <NumberInput
                id="add_product_tcs"
                name="addProductTcs"
                label="TCS %"
                onFocus={() => {
                  setCurrentComponent("add_product_tcs");
                }}
                value={formState?.tcsPer}
                onChange={(e) => {
                  handleFormChange("tcsPer", +e.target.value);
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "add_product_allow_discount",
                    down: "add_product_box_ptr",
                    right: "add_product_gccess",
                    left: "add_product_max_disc",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <NumberInput
                id="add_product_gccess"
                name="addProductGccess"
                label="GCCESS %"
                value={formState?.gccess}
                onChange={(e) => {
                  handleFormChange("gccess", +e.target.value);
                }}
                onFocus={() => {
                  setCurrentComponent("add_product_gccess");
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "add_product_disc_per",
                    down: "add_product_box_mrp",
                    left: "add_product_tcs",
                    right: "add_product_vat",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <NumberInput
                id="add_product_vat"
                name="addProductVat"
                label="VAT %"
                value={formState?.vat}
                onChange={(e) => {
                  handleFormChange("vat", +e.target.value);
                }}
                onFocus={() => {
                  setCurrentComponent("add_product_vat");
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "add_product_max_disc",
                    down: "add_product_mrp",
                    left: "add_product_gccess",
                    right: "add_product_box_ptr",
                  }),
                }}
              />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            sx={{
              margin: "5px 0 0 5px",
              width: "100%",
            }}
          >
            <Grid item xs={2}>
              <NumberInput
                id="add_product_box_ptr"
                label="Box PTR ₹"
                decimalScale={2}
                value={formState?.boxPtr}
                onChange={(e) => {
                  handleFormChange("boxPtr", +e.target.value);
                }}
                onFocus={() => {
                  setCurrentComponent("add_product_box_ptr");
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    left: "add_product_vat",
                    right: "add_product_box_mrp",
                    down: "add_product_passive_cp",
                    up: "add_product_tcs",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <NumberInput
                id="add_product_box_mrp"
                label="Box MRP ₹"
                decimalScale={2}
                value={formState?.boxMrp}
                onChange={(e) => {
                  handleFormChange("boxMrp", +e.target.value);
                }}
                onFocus={() => {
                  setCurrentComponent("add_product_box_mrp");
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    left: "add_product_box_ptr",
                    right: "add_product_mrp",
                    down: "add_product_rate_itemwise",
                    up: "add_product_gccess",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <NumberInput
                id="add_product_mrp"
                label="MRP ₹"
                value={formState?.passiveMrp}
                onValueChange={(value) => {
                  handleFormChange("passiveMrp", value?.floatValue);
                }}
                onFocus={() => {
                  setCurrentComponent("add_product_mrp");
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    left: "add_product_box_mrp",
                    right: "add_product_markup",
                    up: "add_product_vat",
                    down: "add_product_auto_order_days",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <NumberInput
                id="add_product_markup"
                name="addProductMarkup"
                label="Markup Price ₹"
                value={formState?.markup}
                onValueChange={(value) => {
                  handleFormChange("markup", value?.floatValue);
                }}
                onFocus={() => {
                  setCurrentComponent("add_product_markup");
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    left: "add_product_mrp",
                    right: "add_product_selling_price",
                    down: "add_product_enable_min_max_computation_for_apo",
                    up: "add_product_vat",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <NumberInput
                id="add_product_selling_price"
                name="addProductSellingPrice"
                label="Selling Price ₹"
                value={formState?.sellingPrice}
                onValueChange={(value) => {
                  handleFormChange("sellingPrice", value?.floatValue);
                }}
                onFocus={() => {
                  setCurrentComponent("add_product_selling_price");
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    left: "add_product_markup",
                    right: "add_product_passive_cp",
                    down: "add_product_enable_min_max_computation_for_apo",
                    up: "add_product_vat",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <NumberInput
                id="add_product_scheme"
                name="addProductScheme"
                label="Scheme ₹"
                value={formState?.scheme}
                disabled
              />
            </Grid>
            <Grid item xs={2}>
              <NumberInput
                id="add_product_passive_cp"
                name="addProductPassiveCp"
                label="Cost Price ₹"
                value={formState?.passiveCp}
                onValueChange={(value) => {
                  handleFormChange("passiveCp", value?.floatValue);
                }}
                onFocus={() => {
                  setCurrentComponent("add_product_passive_cp");
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    left: "add_product_selling_price",
                    right: "add_product_rate_itemwise",
                    down: "add_product_min_stock",
                    up: "add_product_box_ptr",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <Checkbox
                id="add_product_rate_itemwise"
                label="Rate Itemwise"
                checked={formState?.rateItemwise}
                onChange={(e) => {
                  handleFormChange("rateItemwise", e.target.checked);
                }}
                onFocus={() => {
                  setCurrentComponent("add_product_rate_itemwise");
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    left: "add_product_passive_cp",
                    right: "add_product_min_stock",
                    down: "add_product_max_stock",
                    up: "add_product_box_mrp",
                  }),
                }}
              />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            sx={{
              margin: "5px 0 0 5px",
              width: "100%",
            }}
          >
            <Grid item xs={2}>
              <NumberInput
                id="add_product_min_stock"
                name="addProductMinStock"
                label="Min Stock"
                value={formState?.minStock}
                decimalScale={0}
                onChange={(e) => {
                  if (!e.target.value) {
                    handleFormChange("minStock", null);
                    return;
                  }
                  handleFormChange("minStock", +e.target.value);
                  removeErrorStateOnChange("add_product_min_stock");
                }}
                onFocus={() => {
                  setCurrentComponent("add_product_min_stock");
                }}
                onBlur={() => {
                  validateForm("add_product_min_stock", formState);
                }}
                error={checkErrorStateExists(
                  "add_product_min_stock",
                  errorState
                )}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "add_product_passive_cp",
                    down: "add_product_min_order_days",
                    left: "add_product_rate_itemwise",
                    right: "add_product_max_stock",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <NumberInput
                id="add_product_max_stock"
                name="addProductMaxStock"
                label="Max Stock"
                value={formState?.maxStock}
                decimalScale={0}
                onChange={(e) => {
                  if (!e.target.value) {
                    handleFormChange("maxStock", null);
                    return;
                  }
                  handleFormChange("maxStock", +e.target.value);
                  removeErrorStateOnChange("add_product_max_stock");
                }}
                onFocus={() => {
                  setCurrentComponent("add_product_max_stock");
                }}
                onBlur={() => {
                  validateForm("add_product_max_stock", formState);
                }}
                error={checkErrorStateExists(
                  "add_product_max_stock",
                  errorState
                )}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "add_product_rate_itemwise",
                    down: "add_product_max_order_days",
                    left: "add_product_min_stock",
                    right: "add_product_auto_order_days",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <NumberInput
                id="add_product_auto_order_days"
                label="Auto order days"
                name="addProductAutoOrderDays"
                decimalScale={0}
                value={formState?.autoOrderDays}
                onChange={(e) => {
                  if (!e.target.value) {
                    handleFormChange("autoOrderDays", null);
                    return;
                  }
                  handleFormChange("autoOrderDays", +e.target.value);
                  removeErrorStateOnChange("add_product_auto_order_days");
                }}
                onFocus={() => {
                  setCurrentComponent("add_product_auto_order_days");
                }}
                error={checkErrorStateExists(
                  "add_product_auto_order_days",
                  errorState
                )}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "add_product_mrp",
                    down: "add_product_auto_order_days",
                    right: "add_product_enable_min_max_computation_for_apo",
                    left: "add_product_max_stock",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <Checkbox
                id="add_product_enable_min_max_computation_for_apo"
                label="Enable min-max computation for APO"
                name="computeMinMax"
                onChange={(e) => {
                  handleFormChange("computeMinMax", e.target.checked);
                }}
                checked={formState?.computeMinMax}
                onFocus={() => {
                  setCurrentComponent(
                    "add_product_enable_min_max_computation_for_apo"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "add_product_markup",
                    down: "add_product_enable_min_max_computation_for_apo",
                    left: "add_product_auto_order_days",
                    right: "add_product_min_order_days",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <NumberInput
                id="add_product_current_stock"
                name="addProductCurrentStock"
                label="Current Stock"
                value={formState?.currentStock}
                disabled
              />
            </Grid>
            <Grid item xs={2}>
              <NumberInput
                id="add_product_min_order_days"
                label="Min Days"
                name="addProductminDays"
                decimalScale={0}
                onChange={(e) => {
                  if (!e.target.value) {
                    handleFormChange("minDays", null);
                    return;
                  }
                  handleFormChange("minDays", +e.target.value);
                  removeErrorStateOnChange("add_product_min_order_days");
                }}
                value={formState?.minDays}
                onFocus={() => {
                  setCurrentComponent("add_product_min_order_days");
                }}
                onBlur={() => {
                  validateForm("add_product_min_order_days", formState);
                }}
                error={checkErrorStateExists(
                  "add_product_min_order_days",
                  errorState
                )}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "add_product_min_stock",
                    down: "add_product_min_order_days",
                    right: "add_product_max_order_days",
                    left: "add_product_enable_min_max_computation_for_apo",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <NumberInput
                id="add_product_max_order_days"
                label="Max Days"
                name="addProductmaxDays"
                decimalScale={0}
                value={formState?.maxDays}
                onChange={(e) => {
                  if (!e.target.value) {
                    handleFormChange("maxDays", null);
                    return;
                  }
                  handleFormChange("maxDays", +e.target.value);
                  removeErrorStateOnChange("add_product_max_order_days");
                }}
                onFocus={() => {
                  setCurrentComponent("add_product_max_order_days");
                }}
                onBlur={() => {
                  validateForm("add_product_max_order_days", formState);
                }}
                error={checkErrorStateExists(
                  "add_product_max_order_days",
                  errorState
                )}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "add_product_max_stock",
                    down: "add_product_max_order_days",
                    right: "add_product_sales_b2b_markup_per",
                    left: "add_product_min_order_days",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <NumberInput
                id="add_product_sales_b2b_markup_per"
                name="b2BOffset"
                label="B2B Markup % (P2)"
                onFocus={() => {
                  setCurrentComponent("add_product_sales_b2b_markup_per");
                }}
                value={formState?.b2BOffset}
                decimalScale={2}
                onValueChange={(value) => {
                  handleFormChange("b2BOffset", value?.floatValue);
                }}
                // disabled={
                //   formState?.b2bForceSellingPrice ||
                //   (formState?.b2bSellingPrice !== null &&
                //     formState?.b2bSellingPrice !== undefined)
                // }
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "add_product_auto_order_days",
                    down: "add_product_sales_b2b_markup_per",
                    right: "add_product_sales_b2b_selling_price",
                    left: "add_product_max_order_days",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <NumberInput
                id="add_product_sales_b2b_selling_price"
                name="b2bSellingPrice"
                label="B2B Selling Price ₹ (P1)"
                onFocus={() => {
                  setCurrentComponent("add_product_sales_b2b_selling_price");
                }}
                value={formState?.b2bSellingPrice}
                decimalScale={2}
                // disabled={
                //   formState?.b2BOffset !== null &&
                //   formState?.b2BOffset !== undefined
                // }
                onValueChange={(value) => {
                  removeErrorStateOnChange(
                    "add_product_sales_b2b_selling_price"
                  );
                  handleFormChange("b2bSellingPrice", value?.floatValue);
                }}
                error={checkErrorStateExists(
                  "add_product_sales_b2b_selling_price",
                  errorState
                )}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "add_product_enable_min_max_computation_for_apo",
                    down: "add_product_sales_b2b_selling_price",
                    right: "add_product_b2b_force_selling_price",
                    left: "add_product_sales_b2b_markup_per",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <Checkbox
                id="add_product_b2b_force_selling_price"
                label="B2B Force Selling Price"
                name="b2bForceSellingPrice"
                onChange={(e) => {
                  handleFormChange("b2bForceSellingPrice", e.target.checked);
                }}
                checked={formState?.b2bForceSellingPrice || false}
                onFocus={() => {
                  setCurrentComponent("add_product_b2b_force_selling_price");
                }}
                // disabled={
                //   formState?.b2BOffset !== null &&
                //   formState?.b2BOffset !== undefined
                // }
                error={checkErrorStateExists(
                  "add_product_b2b_force_selling_price",
                  errorState
                )}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "add_product_enable_min_max_computation_for_apo",
                    down: "add_product_b2b_force_selling_price",
                    left: "add_product_sales_b2b_selling_price",
                    right: "add_product_dp_percentage",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <NumberInput
                id="add_product_dp_percentage"
                name="dpPercentage"
                label="DP %"
                onFocus={() => {
                  setCurrentComponent("add_product_dp_percentage");
                }}
                value={formState?.dpPercentage}
                decimalScale={2}
                isAllowed={withDpPercentageCap}
                onValueChange={(value) => {
                  handleFormChange("dpPercentage", value?.floatValue);
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "add_product_enable_min_max_computation_for_apo",
                    down: "add_product_dp_percentage",
                    left: "add_product_b2b_force_selling_price",
                    right: "add_product_dp_percentage",
                  }),
                }}
              />
            </Grid>
          </Grid>
          {formState?.b2BOffset !== null &&
            formState?.b2BOffset !== undefined &&
            formState?.b2BOffset !== "" &&
            formState?.b2bSellingPrice !== null &&
            formState?.b2bSellingPrice !== undefined &&
            formState?.b2bSellingPrice !== "" && (
              <Grid
                container
                spacing={2}
                sx={{
                  margin: "10px 0 0 5px",
                  width: "100%",
                }}
              >
                <Grid item xs={12}>
                  <Box
                    sx={{
                      backgroundColor: "#fff3cd",
                      border: "1px solid #ffeaa7",
                      borderRadius: "4px",
                      padding: "8px 12px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: "8px" }}
                    >
                      <img
                        src={images.infoIcon}
                        alt="info"
                        style={{
                          width: "16px",
                          height: "16px",
                          flexShrink: 0,
                        }}
                      />
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#f50505",
                          fontSize: "13px",
                          fontWeight: 500,
                        }}
                      >
                        Note: Priority is given to B2B Selling Price when both
                        Markup % and Selling Price are set.
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            )}
        </Grid>
      )}
    </>
  );
};

export default StockOrPricesTab;
